import { generateLogCorrelationKey, type AttributeSource } from '@glomopay/telemetry';

import { logger } from '@/lib/logger';

class EnrichmentContext implements AttributeSource {
  private static readonly SESSION_ID_KEY = 'glomo.otel.session.id';

  private sessionId: string;
  private userId: string | undefined;

  constructor() {
    this.sessionId = this.readStoredSessionId() ?? this.createSessionId();
  }

  getAttributes(): Record<string, string> {
    const attrs: Record<string, string> = { 'session.id': this.sessionId };
    if (this.userId) attrs['user.id'] = this.userId;
    return attrs;
  }

  getSessionId(): string {
    return this.sessionId;
  }

  setUserId(id: string | undefined): void {
    this.userId = id;
  }

  private readStoredSessionId(): string | undefined {
    try {
      return sessionStorage.getItem(EnrichmentContext.SESSION_ID_KEY) ?? undefined;
    } catch (error) {
      logger.error('session id sessionStorage read unavailable, generating a new session', {
        error: error instanceof Error ? error.message : String(error),
      });
      return undefined;
    }
  }

  private createSessionId(): string {
    const id = generateLogCorrelationKey();
    try {
      sessionStorage.setItem(EnrichmentContext.SESSION_ID_KEY, id);
    } catch (error) {
      logger.error('session id sessionStorage write unavailable, session will not persist across reloads', {
        error: error instanceof Error ? error.message : String(error),
      });
    }
    return id;
  }
}

export const enrichmentContext = new EnrichmentContext();
